import { useTranslation } from "react-i18next";
import { css } from "../../../../styled-system/css";
import { VStack } from "../../../../styled-system/jsx";
import { Button } from "./Button";
import { PageContainer } from "./PageContainer";
import { useNavigate } from "@tanstack/react-router";

const UnauthorizedWarning = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(["common"]);

  return (
    <PageContainer>
      <VStack gap={"large"} justifyContent={"center"} alignItems={"center"} paddingY={"xlarge"}>
        <h3 className={css({ fontWeight: "medium" })}>
          {t(($) => $.common.unauthorized["You don't have permission to access this page"])}
        </h3>
        <Button onPress={() => void navigate({ to: "/user/dashboard" })}>
          {t(($) => $.common.unauthorized["Return to Dashboard"])}
        </Button>
      </VStack>
    </PageContainer>
  );
};

export default UnauthorizedWarning;
